// Latinco: página de producto (dibujo de formas, ficha interactiva, historia, guía, perfil de tueste y compra)
(() => {
  const root = document.querySelector('[data-ltn-pdp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const onView = (el, fn, margin = '0px 0px -15% 0px') => {
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      fn(el);
    }, { rootMargin: margin });
    io.observe(el);
  };

  // Formas de marca: se dibujan como contorno
  root.querySelectorAll('[data-draw] path').forEach((p) => p.setAttribute('pathLength', '1'));
  root.querySelectorAll('[data-draw]').forEach((el) => onView(el, () => el.classList.add('is-drawn'), '0px'));

  // Escena fija: el empaque gira y la forma de marca pasa de piso a anillo; luego aparece la ficha
  const scene = root.querySelector("[data-scene]");
  const box = root.querySelector("[data-box]");
  if (box) {
    const [x1, y1, x2, y2] = (box.dataset.crop || "").split(",").map(Number);
    box.style.setProperty("--img", `url("${box.dataset.src}")`);
    if (x2 > x1 && y2 > y1) {
      const w = x2 - x1, h = y2 - y1;
      box.style.setProperty("--bs", `${(10000 / w).toFixed(2)}% ${(10000 / h).toFixed(2)}%`);
      box.style.setProperty("--bp", `${((x1 / (100 - w)) * 100).toFixed(2)}% ${((y1 / (100 - h)) * 100).toFixed(2)}%`);
      box.style.setProperty("--ratio", (w / h).toFixed(4));
    } else {
      const img = new Image();
      img.onload = () => box.style.setProperty("--ratio", (img.naturalWidth / img.naturalHeight).toFixed(4));
      img.src = box.dataset.src;
    }
  }
  const clamp = (v) => Math.min(1, Math.max(0, v));
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const desktop = matchMedia("(min-width: 901px)");
  const calm = matchMedia("(prefers-reduced-motion: reduce)");
  // Ficha: en escritorio sale una característica por cada paso de la rueda y se lee en el centro
  const title = root.querySelector('[data-center-title]');
  const text = root.querySelector('[data-center-text]');
  const defaults = { title: title?.textContent, text: text?.innerHTML };
  const left = [...root.querySelectorAll('.ltn-pdp__feats--left [data-feat]')];
  const right = [...root.querySelectorAll('.ltn-pdp__feats--right [data-feat]')];
  const feats = left.flatMap((b, i) => [b, right[i]]).concat(right.slice(left.length)).filter(Boolean);
  let current = null;
  const setActive = (btn) => {
    feats.forEach((b) => b.classList.toggle('is-active', b === btn));
    if (!title) return;
    if (btn) { title.textContent = btn.dataset.title; text.textContent = btn.dataset.text; }
    else { title.textContent = defaults.title; text.innerHTML = defaults.text; }
  };
  feats.forEach((btn) => {
    const show = () => btn.closest('.ltn-pdp__feat').classList.contains('is-shown') && setActive(btn);
    btn.addEventListener('mouseenter', show);
    btn.addEventListener('focus', show);
    btn.addEventListener('click', show);
  });
  scene?.addEventListener('mouseleave', () => setActive(current));

  // Tramos de la escena (0→1): giro y forma, ficha, una parada por característica y fundido final
  const reveal = root.querySelector('.ltn-pdp__reveal');
  const N = feats.length;
  const A_END = 0.12, F_START = 0.2, F_END = 0.8;
  // Cada paso de la rueda muestra dos características (una fila: izquierda y derecha)
  const PER = 2;
  const steps = Math.ceil(N / PER);
  const fStep = (F_END - F_START) / Math.max(1, steps - 1);
  const STOPS = [0, A_END, ...Array.from({ length: steps }, (_, i) => F_START + i * fStep), 1];
  const pin = root.querySelector('.ltn-pdp__pin');
  // La escena se fija justo debajo de la barra superior (que queda visible)
  const headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    const setTop = () => root.style.setProperty('--pdp-top', `${headerGroup.offsetHeight}px`);
    new ResizeObserver(setTop).observe(headerGroup);
    setTop();
  }
  const pinTop = () => parseFloat(getComputedStyle(pin).top) || 0;
  const span = () => scene.offsetHeight - pin.offsetHeight;
  const raw = () => (pinTop() - scene.getBoundingClientRect().top) / span();
  const mobile = { t: 0, to: 0, run: false, last: 0 };
  const tween = (now) => {
    const dt = (now - mobile.last) / 1600;
    mobile.last = now;
    mobile.t = mobile.to > mobile.t ? Math.min(mobile.to, mobile.t + dt) : Math.max(mobile.to, mobile.t - dt);
    paint();
    if (mobile.t !== mobile.to) requestAnimationFrame(tween); else mobile.run = false;
  };
  const paint = () => {
    if (!scene) return;
    let a, b, c = 0, d = 0, e = 0, shown;
    if (desktop.matches) {
      const p = clamp(raw());
      a = ease(clamp(p / A_END));
      b = clamp((p - A_END * 0.6) / (A_END * 0.4));
      c = clamp((p - F_END - 0.02) / 0.05);
      d = ease(clamp((p - F_END - 0.05) / 0.09));
      e = clamp((p - 0.94) / 0.05);
      shown = p < F_START - fStep * 0.5 ? 0 : Math.min(N, (Math.floor((p - F_START) / fStep + 0.5) + 1) * PER);
    } else {
      // En celular el giro se reproduce completo apenas se empieza a bajar (y se devuelve al volver arriba)
      const top = scene.getBoundingClientRect().top + scrollY;
      const want = scrollY - top > innerHeight * 0.08 ? 1 : 0;
      if (want !== mobile.to) {
        mobile.to = want;
        if (!mobile.run) { mobile.run = true; mobile.last = performance.now(); requestAnimationFrame(tween); }
      }
      a = ease(mobile.t);
      b = clamp((mobile.t - 0.6) / 0.4);
      shown = b > 0.6 ? N : 0;
    }
    scene.style.setProperty('--a', a.toFixed(4));
    scene.style.setProperty('--b', b.toFixed(4));
    scene.style.setProperty('--c', c.toFixed(4));
    scene.style.setProperty('--d', d.toFixed(4));
    scene.style.setProperty('--e', e.toFixed(4));
    reveal?.classList.toggle('is-open', e > 0.5);
    feats.forEach((btn, i) => btn.closest('.ltn-pdp__feat').classList.toggle('is-shown', i < shown));
    const next = desktop.matches && shown ? feats[Math.floor((shown - 1) / PER) * PER] : null;
    if (next !== current) {
      current = next;
      setActive(current);
      if (current) feats.slice(feats.indexOf(current), feats.indexOf(current) + PER).forEach((b) => b.classList.add('is-active'));
    }
  };
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; paint(); });
  };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  paint();

  // En escritorio cada intento de bajar o subir con la rueda lleva a la siguiente parada de la escena
  let gliding = false;
  const glide = (to, dur) => {
    const from = scrollY, dist = to - from, t0 = performance.now();
    gliding = true;
    const step = (now) => {
      const t = clamp((now - t0) / dur);
      scrollTo(0, from + dist * ease(t));
      if (t < 1) requestAnimationFrame(step); else setTimeout(() => (gliding = false), 90);
    };
    requestAnimationFrame(step);
  };
  addEventListener('wheel', (e) => {
    if (!scene || !desktop.matches || calm.matches || Math.abs(e.deltaY) < 2) return;
    const p = raw();
    if (gliding) { if (p > -0.2 && p < 1.001) e.preventDefault(); return; }
    let target;
    if (e.deltaY > 0 && p > -0.2 && p < 0.995) target = STOPS.find((s) => s > p + 0.005);
    if (e.deltaY < 0 && p > 0.005 && p <= 1.001) target = [...STOPS].reverse().find((s) => s < p - 0.005);
    if (target === undefined) return;
    e.preventDefault();
    const big = Math.max(p, target) <= A_END + 0.001;
    const exit = target === 1 || p >= 0.999;
    glide(scene.getBoundingClientRect().top + scrollY - pinTop() + target * span(), exit ? 1400 : big ? 950 : 420);
  }, { passive: false });

  // Historia: mostrar más / menos
  const story = root.querySelector('[data-story]');
  const more = root.querySelector('[data-story-toggle]');
  if (story && more) {
    const label = more.textContent;
    if (story.scrollHeight <= story.clientHeight + 4) more.hidden = true;
    more.addEventListener('click', () => {
      const open = story.classList.toggle('is-open');
      more.textContent = open ? more.dataset.less : label;
    });
  }

  // Guía de preparación: pestañas
  root.querySelectorAll('[data-guide]').forEach((tab) =>
    tab.addEventListener('click', () => {
      root.querySelectorAll('[data-guide]').forEach((t) => t.setAttribute('aria-selected', t === tab));
      root.querySelectorAll('[data-guide-panel]').forEach((p) => (p.hidden = p.dataset.guidePanel !== tab.dataset.guide));
    })
  );

  // Compra: cantidad y precio según presentación
  const form = root.querySelector('#LtnBuy');
  if (form) {
    const qty = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-qty]').forEach((b) =>
      b.addEventListener('click', () => {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qty));
      })
    );
    const select = form.querySelector('[data-variant]');
    const price = form.querySelector('[data-price-label]');
    select?.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      if (opt?.dataset.price) price.textContent = opt.dataset.price;
    });
  }

  // Perfil de tueste: temperatura del grano (azul, suave) y velocidad de subida (rojo, con el ruido de la sonda), animadas
  const roast = root.querySelector('[data-roast]');
  const chart = root.querySelector('[data-chart]');
  if (roast && chart) {
    const given = (roast.dataset.curve || '').split(',').map((n) => parseFloat(n)).filter((n) => !Number.isNaN(n));
    const DT = 2; // segundos por muestra
    let temps;
    if (given.length >= 4) {
      // Datos reales: una temperatura cada 30 s, interpolada cada 2 s
      temps = [];
      for (let t = 0; t <= (given.length - 1) * 30; t += DT) {
        const i = Math.min(given.length - 2, Math.floor(t / 30)), f = t / 30 - i;
        temps.push(given[i] + (given[i + 1] - given[i]) * f);
      }
    } else {
      // Curva de referencia con la carga, el final y la duración de la ficha (por defecto 210 °C → 205 °C en 11 min)
      const charge = parseFloat(roast.dataset.charge) || 210, end = parseFloat(roast.dataset.end) || 205;
      const D = Math.round((parseFloat(roast.dataset.minutes) || 11) * 60), tp = Math.round(D * 0.145), low = Math.round(charge * 0.47);
      const rate = (t) => (t <= tp ? 0 : (1 - Math.exp(-(t - tp) / 28)) * (1 - 0.78 * Math.pow((t - tp) / (D - tp), 1.1)));
      let area = 0;
      for (let t = tp; t < D; t += DT) area += rate(t) * DT;
      const k = (end - low) / area;
      temps = [];
      let bt = low;
      for (let t = 0; t <= D; t += DT) {
        if (t <= tp) temps.push(low + (charge - low) * Math.pow(1 - t / tp, 2.2));
        else { bt += rate(t) * k * DT; temps.push(bt); }
      }
    }
    // Velocidad de subida en °C/min, suavizada, con un poco de ruido de lectura
    let seed = 7;
    const rnd = () => ((seed = (seed * 16807) % 2147483647) / 2147483647 - 0.5);
    const ror = temps.map((v, i) => {
      const j = Math.max(0, i - 15);
      return i < 2 ? 0 : Math.max(0, ((v - temps[j]) / ((i - j) * DT)) * 60);
    }).map((v, i, arr) => (v <= 0.05 ? 0 : Math.max(0, v + rnd() * 0.9 + Math.sin(i / 9) * 0.25 + (arr[i] > 0 ? 0 : 0))));
    const W = 1000, H = 440, pad = { l: 60, r: 50, t: 16, b: 46 };
    const minT = 50, maxT = Math.max(250, Math.ceil(Math.max(...temps) / 50) * 50);
    const maxR = Math.max(20, Math.ceil(Math.max(...ror) / 5) * 5);
    const n = temps.length - 1, total = n * DT;
    const x = (i) => pad.l + (i / n) * (W - pad.l - pad.r);
    const yT = (v) => pad.t + (1 - (v - minT) / (maxT - minT)) * (H - pad.t - pad.b);
    const yR = (v) => pad.t + (1 - v / maxR) * (H - pad.t - pad.b);
    const path = (arr, y) => arr.map((v, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)} ${y(v).toFixed(1)}`).join('');
    let grid = '';
    for (let v = minT; v <= maxT; v += 25) {
      grid += `<line x1="${pad.l}" x2="${W - pad.r}" y1="${yT(v)}" y2="${yT(v)}"/>`;
      if (v % 50 === 0) grid += `<text x="${pad.l - 10}" y="${yT(v) + 4}" text-anchor="end">${v}°</text>`;
    }
    for (let v = 0; v <= maxR; v += maxR / 5) grid += `<text x="${W - pad.r + 10}" y="${yR(v) + 4}">${Math.round(v)}</text>`;
    for (let m = 0; m * 60 <= total; m++) grid += `<text x="${x((m * 60) / DT)}" y="${H - 22}" text-anchor="middle">${m}′</text>`;
    grid += `<text class="is-axis" x="${(W) / 2}" y="${H - 2}" text-anchor="middle">${chart.dataset.axis || 'MIN'}</text>`;
    chart.innerHTML = `<svg viewBox="0 0 ${W} ${H}" preserveAspectRatio="none">
      <g class="ltn-pdp__grid">${grid}</g>
      <path class="ltn-pdp__line ltn-pdp__line--ror" d="${path(ror, yR)}" pathLength="1"/>
      <path class="ltn-pdp__line ltn-pdp__line--bean" d="${path(temps, yT)}" pathLength="1"/>
    </svg>`;
    onView(chart, () => chart.classList.add('is-drawn'));
  }
})();
